import React, { useState, useContext, useMemo, useEffect } from "react";
import { faEdit, faPhone, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import { matchPath } from "react-router";
import Logo from "../assets/Logo.svg";
import Fire from "../api/Fire";
import Empty from "./Empty";
import CartItem from "./CartItem";
import CartContext from "../contexts/cart";
import Dialog from "./Dialog";

const RightSideBar = (props) => {
  const { t } = useTranslation();
  const { cart } = useContext(CartContext);
  const [message, setMessage] = useState("");
  const [visible, setVisible] = useState(false);
  const [type, setType] = useState(1);
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState([]);

  useEffect(() => {
    if (cart.length === cartItems.length) {
      let list = [...cartItems].map((item, i) => {
        return { ...item, quantity: cart[i].quantity };
      });
      setCartItems(list);
    } else {
      (async () => {
        let list = [];
        for (const item of cart) {
          const p = await (item.type === "basket" ? Fire._getBasket(item.id) : Fire._getProduct(item.id));
          list.push({
            ...p,
            maxQuantity: p.quantity,
            quantity: item.quantity,
            price: p.sale && new Date() < new Date(p.saleEnd) ? p.price - p.price * (p.sale / 100) : p.price,
          });
        }
        setCartItems(list);
      })();
    }
  }, [cart]);

  const year = useMemo(() => {
    const now = new Date();
    return now.getFullYear();
  }, []);

  const _updateUser = async (e) => {
    e.preventDefault();
    setVisible(true);
    try {
      setLoading((prev) => true);
      await Fire._updateUser(e.target.username.value.trim(), e.target.phone.value.trim());
      setType(1);
      setMessage(t("userUpdated"));
      setVisible(true);
    } catch (error) {
      setType(2);
      setMessage(error.message);
      setVisible(true);
    } finally {
      setLoading((prev) => false);
    }
  };

  const _handleCheckout = () => {
    if (cart.length === 0) return;
    props.history.push({ pathname: "/checkout/", state: { items: cartItems } });
  };

  const _deleteAllCartItems = async () => {
    await Fire._updateCart({ items: [] });
  };

  /* Set the width of the side navigation to 0 */
  const closeNav = () => {
    document.getElementById(t("language") === "en" ? "menu" : "menu-en").style.width = "0px";
    document.getElementById(t("language") === "en" ? "menu" : "menu-en").style.paddingInline = "0";
  };

  const _renderCart = () => {
    let overallPrice = 0;

    return (
      <div className="sideCard cart">
        <div className="border-bottom d-flex p-1">
          <h5 className="flex-fill">
            <strong>{t("cart")}</strong>
          </h5>
          <FontAwesomeIcon className="hoverable" icon={faTrash} size="lg" color="red" onClick={_deleteAllCartItems} />
        </div>

        <div className="flex-fill overflow-auto">
          {cartItems.length > 0 ? (
            cartItems.map((item, index) => {
              overallPrice += item.price * item.quantity;
              return <CartItem key={index} item={item} />;
            })
          ) : (
            <Empty text={t("emptyCart")} small />
          )}
        </div>

        <hr className="text-muted" />
        <button className="btn btn-success rounded-pill w-100 p-1" onClick={_handleCheckout}>
          {t("checkout")} ({overallPrice.toFixed(2)} {t("SAR")})
        </button>
      </div>
    );
  };

  return (
    <div className="sideBar">
      {Fire.currentUser ? (
        <div>
          {edit ? (
            <form className="text-center sideCard" onSubmit={_updateUser}>
              <input
                type="text"
                id="username"
                className="form-control border-0 mb-3 bg-light p-2 w-100 rounded-pill"
                placeholder={t("username-place")}
                defaultValue={Fire.currentUser.displayName}
                required
              />
              <input
                type="number"
                id="phone"
                className="form-control border-0 my-3 bg-light p-2 w-100 rounded-pill"
                placeholder={t("phone-place")}
                defaultValue={Fire.currentUser.photoURL}
                required
              />
              {loading ? (
                <div className="spinner-grow text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <div className="d-flex justify-content-around">
                  <button id="sign-in-button" className="btn btn-success">
                    {t("confirm")}
                  </button>
                  <button id="sign-in-button" type="button" className="btn btn-danger" onClick={() => setEdit(false)}>
                    {t("cancel")}
                  </button>
                </div>
              )}
            </form>
          ) : (
            <div className="sideCard">
              <div className="d-flex align-items-center ">
                <div className="flex-fill">
                  <h5>
                    <strong>{Fire.currentUser.displayName || "???????"}</strong>
                  </h5>
                  <div>
                    <FontAwesomeIcon icon={faPhone} size="xs" color="#000" />
                    <strong className="mx-1">{Fire.currentUser.photoURL || "???????"}</strong>
                  </div>
                </div>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="lg"
                  color="#000"
                  className="hoverable"
                  onClick={() => setEdit(true)}
                />
              </div>
              <button className="btn btn-primary rounded-pill w-100 p-1 mt-3" onClick={() => Fire._signOut()}>
                {t("logout")}
              </button>
            </div>
          )}

          {!!matchPath(props.location.pathname, "/checkout/") ? null : _renderCart()}
        </div>
      ) : (
        <div
          className="sideCard"
          onClick={() => {
            props.history.push({ pathname: "/login" });
            closeNav();
          }}
        >
          <button className="btn btn-primary rounded-pill w-100 p-1" onClick={_handleCheckout}>
            {t("login")}
          </button>
        </div>
      )}

      <hr className="text-muted" />

      <div className="text-center">
        <img src={Logo} alt="brand" className="img-fluid" />

        <div className="text-muted" style={{ fontSize: 12 }}>
          {t("copyright")} ©{year}
        </div>
      </div>

      <Dialog visible={visible} onHide={() => setVisible(false)} message={message} type={type} />
    </div>
  );
};

export default withRouter(RightSideBar);
